// Generated by ts-to-zod
import { z } from 'zod';

export const sampleIntervalDtoSchema = z.object({
  min: z.string().optional(),
  max: z.string().optional(),
});

export const signalPrecisionDtoSchema = z.union([
  z.literal('low'),
  z.literal('medium'),
  z.literal('high'),
  z.literal('unknown'),
]);

export const positionDtoSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  displayNameShort: z.string(),
});

export const baseUnitDtoSchema = z.object({
  ucumCode: z.string(),
});

export const valueRangeDtoSchema = z.object({
  min: z.number(),
  max: z.number(),
});

export const signalReferenceDtoSchema = z.object({
  signalName: z.string(),
  position: positionDtoSchema.optional(),
});

export const unitDtoSchema = z.object({
  expectedValueRange: valueRangeDtoSchema.optional(),
  ucumCode: z.string(),
  translatedUnit: z.string().optional(),
});

export const unitDetailDtoSchema = z.object({
  unit: unitDtoSchema,
  baseUnit: baseUnitDtoSchema,
});

export const signalMetadataDtoSchema = z.object({
  baseSignalName: z.string(),
  displayName: z.string().optional(),
  signals: z.array(signalReferenceDtoSchema),
  sampleInterval: sampleIntervalDtoSchema.optional(),
  precision: signalPrecisionDtoSchema.optional(),
  unitDetail: unitDetailDtoSchema,
});
